import { IAdditionalCommentsLimit } from "src/common/types";
import { getCall } from "src/services";

export const getAdditionalCommentsLimit = (): Promise<IAdditionalCommentsLimit> => {
  return getCall({
    url: "/v1/feedback/talk/questionnaire/comments/limit"
  }) as Promise<IAdditionalCommentsLimit>;
};

export const fetchAdditionalCommentsLimit = () => ({
  type: "GET_ADDITIONAL_COMMENTS_LIMIT"
});
